import { isAppBankIdSupported } from '~/components/app-bridge/app-properties.js';
/**
 * __CONFIGURATION__
 * @namespace
 * @global
 */
const EMPTY_OBJ = {};
// const EMPTY_ARRAY = [];
const configuration = window.__CONFIGURATION__ || EMPTY_OBJ;
delete window.__CONFIGURATION__;

/* GRANEN-781,  We want BankId *disabled* for native apps for now
 Until we can detect native app server side we can emulate this.

 Server side:
 map.put("useTrustlyLogin", (isAnonymous || showLoginAsGuestOption) &&
		!featureHandlerFactory.create(MobileFeatures.BankIdNoAccount).isEnabled());
 */

configuration.isIOSApp = Boolean(
	window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ZHBridge
);
if (configuration.isIOSApp) {
	if (!isAppBankIdSupported()) {
		configuration.useTrustlyLogin = configuration.isAnonymous || configuration.showLoginAsGuestOption;
	}
}

export default Object.freeze(configuration);
